import React from 'react';
import { InfoIcon } from 'lucide-react';
import { afterPurchase } from '../data/content';
export function AfterPurchase() {
  return <section className="bg-parchment-light text-ink" data-id="element-19" data-mp="21ywjpiqvp0zd">
      <div className="mx-auto max-w-content px-5 py-14 sm:px-6 lg:py-24" data-id="element-20" data-mp="26wy3k5w4p4bw">
        <h2 className="text-center font-display text-[1.875rem] font-semibold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-21" data-mp="26vmze4yrtuk9">
          {afterPurchase.title}
        </h2>

        <ol className="mx-auto mt-10 grid max-w-md gap-3 md:max-w-none md:grid-cols-2 lg:grid-cols-4 lg:gap-5" data-id="element-22" data-mp="2gmzst107wsse">
          {afterPurchase.steps.map((step, index) => <li key={step.title} className="flex gap-4 rounded-2xl border border-parchment-line bg-white p-5 lg:flex-col lg:gap-4 lg:p-6" data-id="element-23" data-mp="2pp0o3sbw54rf" data-mpi={index}>
              <span className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-leaf font-display text-base font-semibold text-white" data-id="element-24" data-mp="vag6joiv9pc9">
                {index + 1}
              </span>
              <div data-id="element-25" data-mp="ws8l4nc9otsy">
                <h3 className="font-display text-lg font-semibold leading-snug text-ink" data-id="element-26" data-mp="wss509lh9s9m">
                  {step.title}
                </h3>
                <p className="mt-1 font-sans text-[0.95rem] leading-relaxed text-ink-soft" data-id="element-27" data-mp="rzfeftx8nbe8">
                  {step.description}
                </p>
              </div>
            </li>)}
        </ol>

        <p className="mx-auto mt-8 flex max-w-2xl items-start gap-3 rounded-2xl border border-leaf/30 bg-leaf-soft px-5 py-4 font-sans text-[0.95rem] font-medium leading-relaxed text-ink sm:items-center sm:justify-center sm:text-center" data-id="element-28" data-mp="1fqul1yw1seva">
          <InfoIcon className="mt-0.5 h-5 w-5 flex-none text-leaf sm:mt-0" aria-hidden="true" data-id="element-29" data-mp="16p3jn68jiu78" />
          {afterPurchase.note}
        </p>
      </div>
    </section>;
}